import React from 'react';
import SocialIcons from './SocialIcons';

const Separator = () => <div className="Separator">|</div>;
const Footer = () => {
    return (
        <div className="Footer">
            <div className="info">
                <div>Youth Camps For Christ, Inc.</div>
                <Separator />
                <div>190 Mangum Lane, Littleton, NC 27850</div>
                <Separator />
                <a href="mailto:info@youthcampsforchrist.org">
                    info@youthcampsforchrist.org
                </a>
                <Separator />
                <a href="tel:2525864665">252.586.4665</a>
            </div>
            <SocialIcons />
        </div>
    );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js